import { ValidatorRule } from './validatorRule.constants';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import { IErrorMessage } from '../components/errorMessage/errorMessage.type';

export const YearSelectValidator = (value: string) => {
    const MAX_LENGTH = 4;
    return value.length < MAX_LENGTH;
};

export const JPYearSelectValidator = (value: string) => {
    return /^[1-9]\d{3}/g.test(value);
};

export const MonthSelectValidator = (value: string) => {
    const MAX_LENGTH = 2;
    return value.length < MAX_LENGTH;
};

export const DaySelectValidator = (value: string) => {
    const MAX_LENGTH = 2;
    return value.length < MAX_LENGTH;
};

export const EighteenYearsAgoValidator = (value: Date) => {
    const MIN_AGE = 18;
    const today = new Date();
    const eighteenYearsAgo = new Date(today.setFullYear(today.getFullYear() - MIN_AGE));
    return value.getTime() < eighteenYearsAgo.getTime();
};

export const MinDateValidator = (value: Date) => {
    const MIN_DATE = new Date('1900-01-01');
    return value > MIN_DATE;
};

export const getFullYear = (year: string): string => {
    const today = new Date();
    const fullYear = today.getFullYear().toString();

    return fullYear.slice(0, -2) + year;
};

export const validateExpiration = (expiryDate: Date) => {
    const today = new Date();

    const expiryDateYear = expiryDate.getFullYear();
    const todayYear = today.getFullYear();

    if (expiryDateYear < todayYear) {
        return false;
    }

    if (expiryDateYear > todayYear + 19) {
        return false;
    }

    if (todayYear === expiryDateYear) {
        const expiryDateMonth = expiryDate.getMonth() + 1;
        const todayMonth = today.getMonth() + 1;
        if (expiryDateMonth < todayMonth) {
            return false;
        }
    }

    return true;
};

export abstract class DobFieldValidator {
    constructor(public yearForm: number) {}

    abstract validation(value: Date): IErrorMessage;
}

class JPDobFieldValidator extends DobFieldValidator {
    validation(dob: Date): IErrorMessage {
        const today = new Date();
        if (dob.getTime() > today.getTime()) {
            return TranslationHelpers.getMessageDescriptor('error.dob_invalid');
        }
        return '';
    }
}

class EUDobFieldValidator extends DobFieldValidator {
    validation(dob: Date): IErrorMessage {
        const MIN_AGE = 18;
        const today = new Date();
        const eighteenYearsAgo = new Date(today.setFullYear(today.getFullYear() - MIN_AGE));
        if (dob.getTime() > eighteenYearsAgo.getTime()) {
            return TranslationHelpers.getMessageDescriptor('error.dob_update');
        }
        return '';
    }
}

export class DobFieldValidatorFactory {
    public static produceDoBFieldValidator(rule: string): DobFieldValidator {
        const thisYear = new Date().getFullYear();
        const MAX_AGE = 100;
        if (rule === ValidatorRule.EUDobRule) {
            return new EUDobFieldValidator(thisYear - MAX_AGE);
        } else if (rule === ValidatorRule.JPDobRule) {
            return new JPDobFieldValidator(1900);
        } else {
            return new EUDobFieldValidator(thisYear - MAX_AGE);
        }
    }
}
